/**
 * belfastpilates-development.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.3.1
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.BelfastpilatesDevelopmentappspotcom) {
      root.BelfastpilatesDevelopmentappspotcom = {};
    }
    root.BelfastpilatesDevelopmentappspotcom.CalendarRequest = factory(root.BelfastpilatesDevelopmentappspotcom.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The CalendarRequest model module.
   * @module model/CalendarRequest
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>CalendarRequest</code>.
   * @alias module:model/CalendarRequest
   * @class
   */
  var exports = function() {
    var _this = this;

















  };

  /**
   * Constructs a <code>CalendarRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/CalendarRequest} obj Optional instance to populate.
   * @return {module:model/CalendarRequest} The populated <code>CalendarRequest</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('allDay')) {
        obj['allDay'] = ApiClient.convertToType(data['allDay'], 'Boolean');
      }
      if (data.hasOwnProperty('availableHours')) {
        obj['availableHours'] = ApiClient.convertToType(data['availableHours'], 'String');
      }
      if (data.hasOwnProperty('codeTag')) {
        obj['codeTag'] = ApiClient.convertToType(data['codeTag'], 'String');
      }
      if (data.hasOwnProperty('countryCode')) {
        obj['countryCode'] = ApiClient.convertToType(data['countryCode'], 'String');
      }
      if (data.hasOwnProperty('dateCreated')) {
        obj['dateCreated'] = ApiClient.convertToType(data['dateCreated'], 'Date');
      }
      if (data.hasOwnProperty('day')) {
        obj['day'] = ApiClient.convertToType(data['day'], 'String');
      }
      if (data.hasOwnProperty('dayOfWeek')) {
        obj['dayOfWeek'] = ApiClient.convertToType(data['dayOfWeek'], 'String');
      }
      if (data.hasOwnProperty('description')) {
        obj['description'] = ApiClient.convertToType(data['description'], 'String');
      }
      if (data.hasOwnProperty('endTime')) {
        obj['endTime'] = ApiClient.convertToType(data['endTime'], 'String');
      }
      if (data.hasOwnProperty('id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'String');
      }
      if (data.hasOwnProperty('lastUpdatedDateTime')) {
        obj['lastUpdatedDateTime'] = ApiClient.convertToType(data['lastUpdatedDateTime'], 'Date');
      }
      if (data.hasOwnProperty('month')) {
        obj['month'] = ApiClient.convertToType(data['month'], 'String');
      }
      if (data.hasOwnProperty('startTime')) {
        obj['startTime'] = ApiClient.convertToType(data['startTime'], 'String');
      }
      if (data.hasOwnProperty('type')) {
        obj['type'] = ApiClient.convertToType(data['type'], 'String');
      }
      if (data.hasOwnProperty('userId')) {
        obj['userId'] = ApiClient.convertToType(data['userId'], 'String');
      }
      if (data.hasOwnProperty('year')) {
        obj['year'] = ApiClient.convertToType(data['year'], 'String');
      }
    }
    return obj;
  }

  /**
   * @member {Boolean} allDay
   */
  exports.prototype['allDay'] = undefined;
  /**
   * @member {String} availableHours
   */
  exports.prototype['availableHours'] = undefined;
  /**
   * @member {String} codeTag
   */
  exports.prototype['codeTag'] = undefined;
  /**
   * @member {String} countryCode
   */
  exports.prototype['countryCode'] = undefined;
  /**
   * @member {Date} dateCreated
   */
  exports.prototype['dateCreated'] = undefined;
  /**
   * @member {String} day
   */
  exports.prototype['day'] = undefined;
  /**
   * @member {String} dayOfWeek
   */
  exports.prototype['dayOfWeek'] = undefined;
  /**
   * @member {String} description
   */
  exports.prototype['description'] = undefined;
  /**
   * @member {String} endTime
   */
  exports.prototype['endTime'] = undefined;
  /**
   * @member {String} id
   */
  exports.prototype['id'] = undefined;
  /**
   * @member {Date} lastUpdatedDateTime
   */
  exports.prototype['lastUpdatedDateTime'] = undefined;
  /**
   * @member {String} month
   */
  exports.prototype['month'] = undefined;
  /**
   * @member {String} startTime
   */
  exports.prototype['startTime'] = undefined;
  /**
   * @member {String} type
   */
  exports.prototype['type'] = undefined;
  /**
   * @member {String} userId
   */
  exports.prototype['userId'] = undefined;
  /**
   * @member {String} year
   */
  exports.prototype['year'] = undefined;



  return exports;
}));





// WEBPACK FOOTER //
// ./clientLibsDevelopment/src/model/CalendarRequest.js